.wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    width: 100%;
}

.label {
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
    line-height: var(--tempest-leading-snug);
}

.required {
    color: var(--tempest-danger);
    margin-left: 2px;
}

.field {
    position: relative;
    display: flex;
    align-items: center;
}

.select {
    width: 100%;
    height: var(--tempest-control-height-md);
    padding: 0 36px 0 var(--tempest-control-padding-md);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-control-radius);
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-control-font-md);
    line-height: var(--tempest-leading-snug);
    appearance: none;
    cursor: pointer;
    box-shadow: var(--tempest-shadow-xs);
    transition: var(--tempest-transition-color), var(--tempest-transition-shadow);
}

.select:hover:not(:disabled):not(:focus) {
    border-color: var(--tempest-border-strong);
}

.select:focus {
    outline: none;
    border-color: var(--tempest-primary);
    box-shadow: 0 0 0 var(--tempest-focus-ring-width) var(--tempest-focus-ring-color);
}

.select:disabled {
    background-color: var(--tempest-surface);
    cursor: not-allowed;
    color: var(--tempest-text-muted);
    box-shadow: none;
}

.caret {
    position: absolute;
    right: 12px;
    pointer-events: none;
    color: var(--tempest-text-muted);
}

.error .select {
    border-color: var(--tempest-danger);
}

.error .select:focus {
    box-shadow: 0 0 0 var(--tempest-focus-ring-width)
        color-mix(in srgb, var(--tempest-danger) 25%, transparent);
}

.helper {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text-muted);
    line-height: var(--tempest-leading-snug);
}

.errorText {
    font-size: var(--tempest-text-xs);
    color: var(--tempest-danger);
    line-height: var(--tempest-leading-snug);
}

.chipWrapper {
    display: inline-flex;
}

.chip {
    width: auto;
}

.chip .select {
    width: auto;
    height: var(--tempest-control-height-sm);
    padding: 0 30px 0 var(--tempest-space-3);
    border-radius: var(--tempest-radius-full);
    background-color: var(--tempest-surface);
    font-size: var(--tempest-text-sm);
    box-shadow: none;
}

.chip .caret {
    right: 10px;
}
